/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorMessage,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
} from '../models/ErrorMessage';
import {
    type ReceiptResponse,
    ReceiptResponseFromJSON,
    ReceiptResponseToJSON,
} from '../models/ReceiptResponse';

export interface GetReceiptRequest {
    paymentReference: string;
}

/**
 * 
 */
export class SoftpayReceiptControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for getReceipt without sending the request
     */
    async getReceiptRequestOpts(requestParameters: GetReceiptRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentReference'] == null) {
            throw new runtime.RequiredError(
                'paymentReference',
                'Required parameter "paymentReference" was null or undefined when calling getReceipt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/softpay/{paymentReference}/receipt`;
        urlPath = urlPath.replace('{paymentReference}', encodeURIComponent(String(requestParameters['paymentReference'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getReceiptRaw(requestParameters: GetReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReceiptResponse>> {
        const requestOptions = await this.getReceiptRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReceiptResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReceipt(requestParameters: GetReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReceiptResponse> {
        const response = await this.getReceiptRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
